import AuthDataStore from '../../datastores/AuthDataStore';
// eslint-disable-next-line import/no-cycle
import AxiosService from '../axios/api/client/axiosHttpClient';
import constants from '../../../core/constants';
import { HttpMethod } from '../axios/api/client/http.interface';

class AuthDataStoreGraphQL implements AuthDataStore {
  async logIn() {
    return '';
  }

  async refreshToken(refreshToken: string) {
    try {
      const axios = AxiosService.getInstance();
      const result: any = await axios.exchange(
        `${constants.KEYCLOAK.url}realms/${constants.KEYCLOAK.realm}/protocol/openid-connect/token`,
        {
          method: HttpMethod.Post,
          data: `client_id=${constants.KEYCLOAK.clientId}&grant_type=refresh_token&refresh_token=${refreshToken}`
        }
      );
      const data = {
        token: result?.access_token,
        refreshToken: result?.refresh_token
      };
      return data;
    } catch (error) {
      throw new Error('error refresh token');
    }
  }

  async logOut(refreshToken: string) {
    const params = new URLSearchParams();
    params.append('client_id', constants.KEYCLOAK.clientId);
    params.append('refresh_token', refreshToken);
    return '';
  }
}

export default AuthDataStoreGraphQL;
